import {createSelector} from 'reselect';

import {getUIState} from '../../../../ui-selectors';

const getChatState = createSelector([getUIState], (uiState) => uiState.chat);

const getChatChartState = createSelector([getChatState], (chat) => chat.timeseriesChart);

const getChatbotState = createSelector([getUIState], (uiState) => uiState.chatbot);

const getChatbotChartState = createSelector(
    [getChatbotState],
    (chatbot) => chatbot.timeseriesChart
);

export const getCurrentReportChartIsLoading = createSelector(
    [getChatChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChartTimedOut = createSelector(
    [getChatChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChartErrored = createSelector(
    [getChatChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentReportChartData = createSelector(
    [getChatChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);

export const getCurrentChatbotReportChartIsLoading = createSelector(
    [getChatbotChartState],
    (timeseriesChartState) => timeseriesChartState.isLoading
);

export const isChatbotChartTimedOut = createSelector(
    [getChatbotChartState],
    (timeseriesChartState) => timeseriesChartState.isTimedOut
);

export const isChatbotChartErrored = createSelector(
    [getChatbotChartState],
    (timeseriesChartState) => timeseriesChartState.isErrored
);

export const getCurrentChatbotReportChartData = createSelector(
    [getChatbotChartState],
    (timeseriesChartState) => timeseriesChartState.chartData
);
